import { Usuario } from "../despacho/Usuario";

export class NivelControlCredito {
    id: string;
    nombreNivel: string;
    excedidoAutorizado: number;
    excedidoAutorizadoUSD: number;
    excedidoActivo: boolean;
    vencidoAutorizado: number;
    vencidoAutorizadoUSD: number;
    vencidoActivo: boolean;
    apruebaBloqueo: boolean;
    usuarios?: UsuarioNivelControlCredito[];
    delegaciones?: UsuarioNivelControlCredito[];
}

export class UsuarioNivelControlCredito {
    nivelId: string;
    usuario: Usuario;
    fechaDesde?: string;
    fechaHasta?: string;
    usuarioOtorgador?: Usuario;
    motivo: string;
}